<template>
<div class="tab-bar-frame"  @touchmove.prevent>
  <div class="tab-bar-topborder"></div>
  <div class="tab-bar" >
      <span class="item" @click="switchTo('/find')">
        <img :src="checkPath('/find') ? tabBarImgArr[0].selected : tabBarImgArr[0].normal" alt="">
        <span :class="{active:checkPath('/find')}">发现</span>
      </span>
      <span class="item" @click="switchTo('/type')">
        <img :src="checkPath('/type') ? tabBarImgArr[1].selected : tabBarImgArr[1].normal" alt="">
        <span :class="{active:checkPath('/type')}">分类</span>
      </span>
      <span class="item" @click="switchTo('/study')">
        <img :src="checkPath('/study') ? tabBarImgArr[2].selected : tabBarImgArr[2].normal" alt="">
        <span :class="{active:checkPath('/study')}">我的书架</span>
      </span>
      <span class="item" @click="switchTo('/exchange')">
        <img :src="checkPath('/exchange') ? tabBarImgArr[3].selected : tabBarImgArr[3].normal" alt="">
        <span :class="{active:checkPath('/exchange')}">兑换/激活</span>
      </span>
      <span class="item" @click="switchTo('/mine')">
        <img :src="checkPath('/mine') ? tabBarImgArr[4].selected : tabBarImgArr[4].normal" alt="">
        <span :class="{active:checkPath('/mine')}">我的</span>
      </span> 
  </div>
  <div class="footer" v-show="$store.state.isPC">
      <div class="zs">
          <a href="http://www.bracebook.com.cn/images/business_licence.png" target="_blank">营业执照</a><span style="margin:0 10px;">|</span> <a href="http://www.bracebook.com.cn/images/publish_licence.png" target="_blank">出版物经营许可证</a>
      </div>
      <div class="bq">
        Copyright ©2020北京博瑞森管理咨询有限公司 版权所有 <a href="http://www.beian.miit.gov.cn/" target="_blank">京ICP备13015193号-2</a>
      </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'TabBar',
  data () {
    return {
      tabBarImgArr:[
        {
          normal:require('./../assets/images/nav/tab_find_black.png'),
          selected:require('./../assets/images/nav/tab_find_blue.png'),
        },
        {
         normal:require('./../assets/images/nav/tab_type_black.png'),
          selected:require('./../assets/images/nav/tab_type_blue.png'),
        },
        {
         normal:require('./../assets/images/nav/tab_study_black.png'),
          selected:require('./../assets/images/nav/tab_study_blue.png'),
        },
        {
          normal:require('./../assets/images/nav/tab_exchange_black.png'),
          selected:require('./../assets/images/nav/tab_exchange_blue.png'),
        },
        {
          normal:require('./../assets/images/nav/tab_mine_black.png'),
          selected:require('./../assets/images/nav/tab_mine_blue.png'),
        },
      ]
    }
  },
  created:function(){
   
  },
  methods:{
    checkPath(path){
      if(this.$route.path.indexOf(path)!=-1){
        return true;
      }
      return false;
    },
    //2.切换路由的函数，接收一个参数，该参数为要切换的路径
    switchTo(path){
     // alert(this.$router)
      this.$router.push(path);
    },
   
  }
}
</script>


<style scoped>
  .tab-bar-frame{
    position: absolute;
    bottom:0;
    width:100%;
  }
  .tab-bar-topborder {
    height: 8px;
    width: 100%;
    background: -webkit-gradient(linear,center top,center bottom,from(#ffffff), to(#f7f7f7));
    opacity:0.6;
  }
  .tab-bar {
    height: 52px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
  }

  .tab-bar .item {
    display: flex;
    font-size: 10px;
    flex: 1;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    color: #333333;
  }

  /* span标签的选active中样式 */
  .tab-bar .item span.active {
    color: #8396FC;
  }

  .tab-bar .item img {
    width: 20px;
    margin-bottom:3px;
  }

/* 发现图标有点过大了，这里特别设置小一点 */
  .tab-bar .item img.exp {
    width: 20px;
  }
  .footer{
      height:50px;background: #f1f1f1;color:#666666;font-size:12px;
      text-align:center;line-height:20px;padding-top:5px;
  }
  .footer a{
    color:#666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/TabBar.vue